import { actionLoadingComplete, actionLoadingProgress, actionLoadingStart } from "./actionLoading";
export var createLoaderEventToActionMapper = function (id) { return function (loader) {
    if (loader.progress === 0) {
        return actionLoadingStart(id, loader);
    }
    else if (Math.round(loader.progress) >= 100) {
        return actionLoadingComplete(id, loader);
    }
    return actionLoadingProgress(id, loader);
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/createLoaderEventToActionMapper.ts
// module id = 562
// module chunks = 3